import styled from 'styled-components'

const StyledShareOptions = styled.div`
  position: relative;
  
  .share-btn {
    display: grid;
    justify-items: center;
    grid-gap: 5px;
    height: fit-content;
    padding: 5px;
    font-size: 15px;
    border-radius: 3px;
    font-weight: 600;

    svg {
      height: 20px;
    }
  }

  .share-tooltip {
    background: ${({ theme }) => theme.colors.background};
    border: 1px solid ${({ theme }) => theme.colors.gray[200]};
    box-shadow: none;
    border-radius: 3px;
    position: absolute;
    right: 0;
    bottom: calc(100% + 8px);
    opacity: 0;
    transition: box-shadow 0.4s, opacity 0.2s;
    z-index: ${({ theme }) => theme.elevations.tooltip};
    
    .share-tooltip-content {
      padding: 5px;
      background: ${({ theme }) => theme.colors.background};
      border-radius: 2px;
      display: flex;
      align-items: center;
      z-index: 1;
      position: relative;

      a {
        width: 26px;
        height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        color: ${({ theme }) => theme.colors.gray[700]};
        transition: 0.2s;
        
        svg {
          height: 20px;
        }

        &:hover {
          color: ${({ theme }) => theme.colors.gray[900]};
          background: ${({ theme }) => theme.colors.gray[100]};
        }
      }

      .copy-btn {
        margin-left: 5px;
      }
    }

    &::after {
      content: "";
      width: 20px;
      height: 20px;
      background: ${({ theme }) => theme.colors.background};
      position: absolute;
      bottom: -4px;
      right: 16px;
      transform: rotate(45deg);
      border-radius: 0 0 0 2px;
      border: 1px solid #ebebeb;
    }
  }

  &:focus-within {
    .share-tooltip {
      opacity: 1;
      box-shadow: 0px 8px 16px 2px rgba(97, 97, 97, 0.1);
    }
  }

  &:not(:last-child) {
    margin-right: 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .share-tooltip {
      left: 0;
      right: unset;
      bottom: calc(100% + 8px);

      &::after {
        left: 16px;
        right: unset;
      }
    }
  }
`

export default StyledShareOptions
